import { useState, useEffect, memo, useCallback } from "react";
import { MapContainer, TileLayer, Marker, Popup } from "react-leaflet";
import AnimacionCarga from "../animacion_de_carga";
import BarraSuperior from "../barra_superior";
import { obtenerGPS } from "../../../functions/consultas";
import "leaflet/dist/leaflet.css";
import L from "leaflet";
import BotonSOS from "../sos/boton_sos";

delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: require("leaflet/dist/images/marker-icon-2x.png"),
  iconUrl:       require("leaflet/dist/images/marker-icon.png"),
  shadowUrl:     require("leaflet/dist/images/marker-shadow.png"),
});

const MAPA_CENTRO = [4.8133, -75.6961];

const coordsValidas = (item) =>
  item.latitud && item.longitud &&
  !isNaN(parseFloat(item.latitud)) &&
  !isNaN(parseFloat(item.longitud));

const ListadoGPS = memo(() => {
  const [datos, setDatos]         = useState([]);
  const [cargando, setCargando]   = useState(true);
  const esAuditor = localStorage.getItem("Permisos") === "AUDITOR";
  const [seleccionado, setSeleccionado] = useState("todos");

  const capturarDatos = useCallback(async () => {
    try {
      const data = await obtenerGPS();
      if (data) {
        const lista = data
          .filter(coordsValidas)
          .map(item => ({
            ...item,
            fecha_hora: `${item.fecha || ""} ${item.hora || ""}`.trim(),
          }));
        setDatos(lista);
        if (esAuditor && lista.length > 0) {
          setSeleccionado(lista[0].cliente || "todos");
        }
      }
    } catch (error) {
      console.error(error);
    } finally {
      setCargando(false);
    }
  }, [esAuditor]);

  useEffect(() => { capturarDatos(); }, [capturarDatos]);

  const puestos = [...new Set(datos.map(d => d.cliente).filter(Boolean))].sort();

  const puntosMostrados = seleccionado === "todos"
    ? datos
    : datos.filter(d => d.cliente === seleccionado);

  const centraMapa = puntosMostrados.length > 0
    ? [parseFloat(puntosMostrados[0].latitud), parseFloat(puntosMostrados[0].longitud)]
    : MAPA_CENTRO;

  if (cargando) return <AnimacionCarga />;

  return (
    <>
      <BarraSuperior />
      <div style={{ display: "flex", flexDirection: "column", height: "calc(100vh - 52px)" }}>

        <div style={{
          display: "flex", alignItems: "center", gap: "16px", padding: "10px 16px",
          background: "#fff", borderBottom: "1px solid #e5e7eb", flexShrink: 0, flexWrap: "wrap"
        }}>
          <label style={{ fontSize: "13px", fontWeight: "600", color: "#374151" }}>Puesto:</label>
          <input
            list="lista-puestos"
            value={seleccionado === "todos" ? "" : seleccionado}
            onChange={e => setSeleccionado(e.target.value || "todos")}
            placeholder={`Buscar entre ${puestos.length} puestos...`}
            style={{ padding: "7px 12px", borderRadius: "6px", border: "1px solid #d1d5db", fontSize: "13px", minWidth: "280px" }}
          />
          <datalist id="lista-puestos">
            {puestos.map(p => <option key={p} value={p} />)}
          </datalist>

          <span style={{ fontSize: "12px", color: "#9ca3af" }}>
            {puntosMostrados.length} registro{puntosMostrados.length !== 1 ? "s" : ""}
          </span>

          <button
            onClick={capturarDatos}
            title="Refrescar"
            style={{
              marginLeft: "auto", padding: "7px 18px", borderRadius: "6px",
              border: "none", background: "#c0392b",
              fontSize: "13px", fontWeight: "600", cursor: "pointer", color: "#fff"
            }}
          >
            <i className="bi bi-arrow-clockwise" />
          </button>
        </div>

        <div style={{ flex: 1 }}>
          <MapContainer
            key={`${centraMapa.join(",")}-${seleccionado}`}
            center={centraMapa}
            zoom={seleccionado === "todos" ? 7 : 15}
            style={{ height: "100%", width: "100%" }}
          >
            <TileLayer
              attribution='&copy; <a href="https://www.openstreetmap.org/">OpenStreetMap</a>'
              url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
            />
            {puntosMostrados.map((u, i) => (
              <Marker key={i} position={[parseFloat(u.latitud), parseFloat(u.longitud)]}>
                <Popup>
                  <strong>{u.cliente}</strong><br />
                  {u.direccion && <>{u.direccion}<br /></>}
                  {u.fecha_hora && <small style={{ color: "#9ca3af" }}>{u.fecha_hora}</small>}
                </Popup>
              </Marker>
            ))}
          </MapContainer>
        </div>
      </div>
      <BotonSOS />
    </>
  );
});

export default ListadoGPS;
